import { useRecoilValue } from "recoil";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { PlatformPeopleSalaryEditRole, UserAdminRole } from "../../../../Component/Common/Constants/UserRoles";
import { PlatformSalary } from "../../../../Component/Model/Dto/Platform/PlatformSalary";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { CurrencyFormatter } from "../../../../Helpers/CurrencyFormatter";
import { userRolesState } from "../../../../State/user.Atom";

interface PlatformSalaryTableRow {
    year: number;
    totalCTC: string;
    actions: ActionType[];
}

export interface PlatformSalaryTable {
    columns: Array<TableColumn>;
    rows: Array<PlatformSalaryTableRow>;
}

export function PlatformSalaryTableMapper(data: PlatformSalary.PlatformSalarySummaryDto[], handleEdit: (year: number) => void, handleDelete: (year: number) => void): PlatformSalaryTable {
    const editRoleAccess = [
        PlatformPeopleSalaryEditRole,
        UserAdminRole
    ]

    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));
    const columns = [
        { Header: 'Year', accessor: 'year', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Total CTC Salary', accessor: 'totalCTC', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    if (data && data.length > 0) {
        const rows = data.map((item: PlatformSalary.PlatformSalarySummaryDto, index: number) => ({
            year: item.year,
            totalCTC: CurrencyFormatter(item.totalCTC),
            actions: [
                isEditable ? 
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        handleEdit(item.year);
                    },
                    icon: {
                        color: 'info',
                        name: 'edit'
                    },
                } : 
                {
                    key: index.toString(),
                    label: 'View',
                    action: () => {
                        handleEdit(item.year);
                    },
                    icon: {
                        color: 'info',
                        name: 'visibility'
                    },
                },
                isEditable &&
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        handleDelete(item.year);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete',
                    },
                }
            ].filter(Boolean) as ActionType[]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

